import { Injectable } from '@angular/core';
import * as Routes from 'src/Routes';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConvoyeurService {

  constructor(private http: HttpClient) { }


  post(formData: FormData): Promise<any> {
    return this.http.post<any>(Routes.CONVOYEUR, formData).toPromise();
  }

  update(formData: FormData, id): Promise<any> {
    return this.http.post<any>(`${Routes.CONVOYEUR}/${id}`, formData).toPromise();
  }

  delete(id: number) {
    return this.http.delete(`${Routes.CONVOYEUR}/${id}`).toPromise();

  }

  find(id: number): Promise<any> {
    return this.http.get<any>(`${Routes.CONVOYEUR}/${id}`).toPromise();
  }
  public gets(page) {
    return this.http.get<any>(`${Routes.CONVOYEUR}?page=${page}`)
      .toPromise();
  }

  public get(url) {
    return this.http.get<any>(`${url}`)
      .toPromise();
  }

  public getFormation() {
    return this.http.get<any>(`${Routes.FORMATION}`)
      .toPromise();
  }

  public getUser() {
    return this.http.get<any>(`${Routes.USER}`)
      .toPromise();
  }

  public getConvoyeur() {
    return this.http.get<any>(`${Routes.CONVOYEUR}`)
      .toPromise();
  }
}
